import { Component, Prop } from 'vue-property-decorator';
import Vue, { CreateElement, VNode, VNodeData, VNodeChildren } from 'vue';
import './styles.styl';
import { Title, ValueView } from '@/components';

@Component({
  name: 'ApartmentsListTileMobile',
})
export default class ApartmentsListTileMobile extends Vue {
  @Prop({type: Object, default: () => {}}) public readonly apartment;

  public render(createElement: CreateElement): VNode {

    const title: VNode = createElement(Title, {
      props: {
        tag: 'h6',
        text: `${(this as any).apartment.apartment} ${(this as any).apartment.number}`,
      },
    });

    const line: VNode = createElement('div', { class: 'line'});

    enum mapper {
      contract = 'contract_number',
      design = 'design_name',
      buildingComplex = 'section',
      floor = 'floor_number',
      rooms = 'rooms',
    }

    const list: VNodeChildren = Object
      .entries(mapper)
      .map((view: [string, string]) => {
        const [name, value] = view;
        return createElement(ValueView, {
          props: {
            name: this.apartment.single[name],
            value: this.apartment[value],
          },
        });
    });

    const data: VNodeData = {
      class: 'apartment-card',
    };
    const children: VNodeChildren = [
      title,
      line,
      list,
    ];
    return createElement('div', data, children);
  }
}
